import { isNil } from "lodash";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

export const getUserFullNameFromEmail = (users, email, emptyVal) => {
  if (isEmpty(users) || !isArray(users)) {
    return null;
  }
  const user = users.find((user) => user.emailAddress === email);
  if (isNil(user) && emptyVal) {
    return emptyVal;
  }
  return user ? user?.fullName : email;
};
